import { resizeObservers as r } from "./ghl-ui.es1655.js";
import { calculateDepthForNode as i } from "./ghl-ui.es1740.js";
var n = function(t) {
  r.forEach(function(e) {
    e.activeTargets.splice(0, e.activeTargets.length), e.skippedTargets.splice(0, e.skippedTargets.length), e.observationTargets.forEach(function(s) {
      s.isActive() && (i(s.target) > t ? e.activeTargets.push(s) : e.skippedTargets.push(s));
    });
  });
};
export {
  n as gatherActiveObservationsAtDepth
};
